import styled from 'styled-components';

import colors from '../../../../styles/colors';
import Tabs from '../../../components/Tabs';
import { StyledTab as Tab, StyledBadge as Badge } from '../../../components/Tabs/styles';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin: 10px 30px;
  height: calc(100% - 30px);
`;

const StyledTabs = styled(Tabs)`
  padding: 0;
  margin-bottom: 16px;
  border-bottom: 1px solid ${colors.shades.secondary7};

  .MuiTabs-indicator {
    display: block;
    height: 2px;
    background-color: ${colors.base.secondary2};
  }

  ${Tab} {
    min-width: unset;
    padding: 12px 20px;
    border-radius: 0;
    background-color: transparent;
    color: ${colors.shades.gamma10};
    font-size: 13px;
    font-weight: 500;
    letter-spacing: 0.5px;
    text-transform: uppercase;

    &.Mui-selected {
      background-color: transparent;
      color: ${colors.base.secondary2};
    }
  }

  ${Badge} {
    .MuiBadge-badge {
      margin-left: 10px;
      border: none;
      background-color: ${colors.shades.danger3};
      color: ${colors.base.alpha};
    }
  }
`;

export {
  Container,
  StyledTabs,
};
